import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../../index';
import StripeSetupInit from './stripe-setup-init';

export function initAdminCardPaymentComponent() {
  document.body.addEventListener('admin-payment-loaded', showPaymentForm);

  function showPaymentForm() {
    document.getElementsByName('admin-payment-element').forEach((element) => {
      if (element.getAttribute('initialized') !== 'true') {
        element.setAttribute('initialized', 'true');
        const root = ReactDOM.createRoot(element);
        const { tenant, contextPath, userId, color, enableCancel, ...props } = Object.assign(
          {},
          element.dataset,
        ) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <StripeSetupInit userId={userId} color={color} enableCancel={enableCancel} {...props} />
            </TenantContext.Provider>,
          ),
        );

        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      }
    });
  }
}
